<script lang="ts">
    import { t } from 'svelte-i18n';
    import BreadcrumbItem from '$lib/daisyUiComponents/BreadcrumbItem.svelte';
    import Breadcrumb from '$lib/daisyUiComponents/Breadcrumb.svelte';
    import { useLocaleContext } from '$lib/context.js';

    export let iframeSrc: string;
    export let pageType: 'termsConditions' | 'privacy' | 'imprint' | 'rightOfRevocation';

    const lang = useLocaleContext();
</script>

<svelte:head>
    <title>{$t(`website.page.${pageType}.meta.title`)}</title>
    <meta name="description" content={$t(`website.page.${pageType}.meta.description`)} />
</svelte:head>

<div class="container py-24 px-4 lg:px-8 max-w-4xl mx-auto">
    <Breadcrumb class="mb-5">
        <BreadcrumbItem href="/{lang}/shop">
            <h1 class="text-secondary text-3xl font-semibold">
                {$t('shop.name')}
            </h1>
        </BreadcrumbItem>
        <BreadcrumbItem>
            <h1 class="text-secondary text-3xl font-semibold">{$t(`website.page.${pageType}.title`)}</h1>
        </BreadcrumbItem>
    </Breadcrumb>
    <div class="prose max-w-full">
        <iframe src={iframeSrc} class="w-full h-[80vh]" title={$t(`website.page.${pageType}.title`)}></iframe>
    </div>
</div>

<style>
    iframe {
        background-color: white;
    }
</style>
